export const phoneReg = /^[1][0-9]{10}$/
export const emailReg = /^[-_A-Za-z0-9]+@([_A-Za-z0-9]+\.)+[A-Za-z0-9]{2,3}$/;